import { Divider } from '@mui/material';
import styled from 'styled-components';
import Typography from '../../atoms/Typography';

export const FeeContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

export const FeeName = styled(Typography)`
  && {
    color: ${({ theme }) => theme.secondaryColor[700]};
    margin-bottom: 0.5rem;
    font-weight: bold;
    
  }
`;

export const FeeDetails = styled.div`
  flex-basis: 70%;
  display: flex;
  flex-direction: column;
`;

export const FeeAmount = styled.div`
  flex-basis: 30%;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  p {
    color: ${({ theme }) => theme.secondaryColor[700]};
    text-transform: uppercase;
  }
`;

export const FeeDivider = styled(Divider)`
  && {
    margin-top: 2rem;
    margin-bottom: 2rem;
    width: 100%;
  }
`;
